import { createAction, createRequestTypes, FAILURE, REQUEST, SUCCESS } from 'utils/actionGenerator';

export const GET_COMMENTS_LIST = createRequestTypes('placement/activity/GET_COMMENTS_LIST');
export const GET_SUB_STAGE_DETAILS = createRequestTypes('placement/activity/GET_SUB_STAGE_DETAILS');
export const POST_SUB_STAGE_DETAILS = createRequestTypes('placement/activity/POST_SUB_STAGE_DETAILS');
export const GET_AUDIT_LIST = createRequestTypes('placement/activity/GET_AUDIT_LIST');
export const POST_COMMENT = createRequestTypes('placement/activity/POST_COMMENT');
export const CLEAR_FLAGS = createRequestTypes('placement/activity/CLEAR_FLAGS');

export const getCommentsList = {
  request: (params) => createAction(GET_COMMENTS_LIST[REQUEST], { params }),
  success: (response) => createAction(GET_COMMENTS_LIST[SUCCESS], { response }),
  failure: (response) => createAction(GET_COMMENTS_LIST[FAILURE], { response }),
  clearFlags: () => createAction(CLEAR_FLAGS),
};

export const getSubStageDetails = {
  request: (params) => createAction(GET_SUB_STAGE_DETAILS[REQUEST], { params }),
  success: (response) => createAction(GET_SUB_STAGE_DETAILS[SUCCESS], { response }),
  failure: (response) => createAction(GET_SUB_STAGE_DETAILS[FAILURE], { response }),
};

export const submitSubStageDetails = {
  request: (payload) => createAction(POST_SUB_STAGE_DETAILS[REQUEST], { payload }),
  success: (response) => createAction(POST_SUB_STAGE_DETAILS[SUCCESS], { response }),
  failure: (response) => createAction(POST_SUB_STAGE_DETAILS[FAILURE], { response }),
};

export const getAuditList = {
  request: (params) => createAction(GET_AUDIT_LIST[REQUEST], { params }),
  success: (response) => createAction(GET_AUDIT_LIST[SUCCESS], { response }),
  failure: (response) => createAction(GET_AUDIT_LIST[FAILURE], { response }),
};

export const postComment = {
  request: (payload) => createAction(POST_COMMENT[REQUEST], { payload }),
  success: (response) => createAction(POST_COMMENT[SUCCESS], { response }),
  failure: (response) => createAction(POST_COMMENT[FAILURE], { response }),
};
